



import img1 from '../images/roadmap/rm-4.jpg'
import img2 from '../images/roadmap/rm-5.jpg'
import img3 from '../images/roadmap/rm-6.jpg'

const dataRoadmap2 = [
    {
        id: 1,
        title: 'PHASE 1',
        img1: img1,
        img2: img2,
        img3: img3,

        list : [
            {
                id: 1,
                text: 'Befriending & Chat Functions',
            },
            {
                id: 2,
                text: 'Challenging Feature',
            },
            {
                id: 3,
                text: 'Corsair Wheel',
            },
            {
                id: 4,
                text: 'Mobile Version Launch',
            },
        ]

    
    },
    {
        id: 2,
        title: 'PHASE 2',
        img1: img1,
        img2: img2,
        img3: img3,

        list : [
            {
                id: 1,
                text: 'Befriending & Chat Functions',
            },
            {
                id: 2,
                text: 'Challenging Feature',
            },
            {
                id: 3,
                text: 'Corsair Wheel',
            },
            {
                id: 4,
                text: 'Mobile Version Launch',
            },
        ]

    
    },
    {
        id: 3,
        title: 'PHASE 3',
        img1: img1,
        img2: img2,
        img3: img3,

        list : [
            {
                id: 1,
                text: 'Befriending & Chat Functions',
            },
            {
                id: 2,
                text: 'Challenging Feature',
            },
            {
                id: 3,
                text: 'Corsair Wheel',
            },
            {
                id: 4,
                text: 'Mobile Version Launch',
            },
        ]

    
    },
    {
        id: 4,
        title: 'PHASE 4',
        img1: img1,
        img2: img2,
        img3: img3,

        list : [
            {
                id: 1,
                text: 'Befriending & Chat Functions',
            },
            {
                id: 2,
                text: 'Challenging Feature',
            },
            {
                id: 3,
                text: 'Corsair Wheel',
            },
            {
                id: 4,
                text: 'Mobile Version Launch',
            },
        ]

    
    },


]

export default dataRoadmap2;